var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 170,
    viewBox: "0 0 186 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.44 42.3086C65.0815 18.6808 71.9022 6.86694 80.8071 2.90223C88.5743 -0.555948 97.4441 -0.555948 105.211 2.90223C114.116 6.86694 120.937 18.6808 134.578 42.3086L166.362 97.3587C180.003 120.986 186.824 132.8 185.805 142.494C184.916 150.95 180.481 158.632 173.603 163.629C165.717 169.359 152.075 169.359 124.792 169.359H61.226C33.943 169.359 20.3015 169.359 12.4155 163.629C5.53707 158.632 1.10217 150.95 0.213444 142.494C-0.805457 132.8 6.01529 120.986 19.6568 97.3586L51.44 42.3086Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.44 42.3086C65.0815 18.6808 71.9022 6.86694 80.8071 2.90223C88.5743 -0.555948 97.4441 -0.555948 105.211 2.90223C114.116 6.86694 120.937 18.6808 134.578 42.3086L166.362 97.3587C180.003 120.986 186.824 132.8 185.805 142.494C184.916 150.95 180.481 158.632 173.603 163.629C165.717 169.359 152.075 169.359 124.792 169.359H61.226C33.943 169.359 20.3015 169.359 12.4155 163.629C5.53707 158.632 1.10217 150.95 0.213444 142.494C-0.805457 132.8 6.01529 120.986 19.6568 97.3586L51.44 42.3086Z",
    fill: "url(#triangle-figure-gradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle-figure-gradient",
    x1: -25.1345,
    y1: -29.6914,
    x2: 78.0434,
    y2: 133.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878134,
    stopColor: "#0043B7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDark);
export default __webpack_public_path__ + "static/media/triangleDark.68534060.svg";
export { ForwardRef as ReactComponent };